module.exports = __webpack_public_path__ + "static/img/lxsemicon-business.f7b2321.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lxsemicon-business.jpg
// module id = b+no
// module chunks = 0